/* @flow */

import React from 'react';
import { Modal, Button, Form } from 'semantic-ui-react';
import Choices from './Choices';
import TargetUsersCounter from './TargetUsersCounter';
import { getFilteredUsers, fetchTags } from 'diffusion/api/index';

type Props = {
  title: string,
  isOpened: boolean,
  roles: Array<UserRole>,
  onSelected: (target: Target) => void,
  onClose: () => void,
};

type State = {
  isFetching: boolean,
  users: Array<TargetUser>,
  tags: Array<String>,
  selectedRole: string,
  selectedTags: Array<String>,
};

export default class DiffusionModal extends React.Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      isFetching: false,
      users: [],
      tags: [],
      selectedRole: 'none',
      selectedTags: [],
    };
  }

  componentDidMount() {
    // Avoid loading tags multiple times
    if (this.state.tags.length) return;

    this.setState({ isFetching: true });

    fetchTags().then(tags => {
      this.setState({
        isFetching: false,
        tags,
      });
    });
  }

  onClose = () => {
    // Clearing current state
    this.setState(
      {
        isFetching: false,
        selectedRole: 'none',
        selectedTags: [],
        users: [],
      },
      this.props.onClose
    );
  };

  refreshUsersSelection = () => {
    const { selectedRole, selectedTags } = this.state;

    getFilteredUsers(selectedRole, selectedTags).then(users =>
      this.setState({ users })
    );
  };

  onTagsChanged = selectedTags => {
    this.setState(
      {
        selectedTags,
      },
      this.refreshUsersSelection
    );
  };

  onRoleChanged = selectedRole => {
    this.setState(
      {
        selectedRole,
      },
      this.refreshUsersSelection
    );
  };

  onValidate = () => {
    const { selectedRole, selectedTags } = this.state;

    const target = {
      role: selectedRole === 'none' ? null : selectedRole,
      tags: selectedTags,
    };

    this.props.onSelected(target);
    this.onClose();
  };

  render() {
    const { title, roles, isOpened } = this.props;
    const { isFetching, users, tags, selectedRole, selectedTags } = this.state;

    const tagsChoices = tags.map(t => ({
      text: t,
      value: t,
    }));

    const roleChoices = roles.map(r => ({
      text: r.label,
      value: r.code,
    }));

    return (
      <Modal open={isOpened} closeIcon onClose={this.onClose}>
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>
          <Form>
            <div className="ui two fields">
              <Choices
                value={selectedRole}
                name="role"
                placeholder="Rôle"
                label="Rôle"
                items={roleChoices}
                onChange={this.onRoleChanged}
              />
            </div>
            <Choices
              value={selectedTags}
              name="tags"
              placeholder="Tags"
              label="Tags"
              loading={isFetching}
              items={tagsChoices}
              onChange={this.onTagsChanged}
              multiple
            />
          </Form>
          <TargetUsersCounter users={users} />
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={this.onClose}
            icon="close"
            labelPosition="left"
            content="Annuler"
          />
          <Button
            onClick={this.onValidate}
            primary
            icon="check"
            labelPosition="right"
            content="Valider"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/DiffusionModal.js